import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllStudentGuidance = () => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.getAllStudentGuidance();
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const getFilteredStudentGuidance = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.getFilteredStudentGuidance(page, pageSize);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const getAllStudentGuidanceByProfileId = (id) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.getAllStudentGuidanceByProfileId(id);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const insertStudentGuidance = (profileId, payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.insertStudentGuidance();
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_SUCCESS,
      id: profileId,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm thành công!",
      }),
    );
    return response;
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: error?.response?.data?.message || "Thêm thất bại!",
      }),
    );
    return { success: false };
  }
};

export const updateStudentGuidance = (id, payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.updateStudentGuidance(id);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_SUCCESS,
      id: id,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: error?.response?.data?.message || "Cập nhật thất bại!",
      }),
    );
    return false;
  }
};

export const deleteStudentGuidance = (id) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.deleteStudentGuidance(id);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_SUCCESS,
      id: id,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xoá thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: error?.response?.data?.message || "Xoá thất bại!",
      }),
    );
    return false;
  }
};

// Sprint 2: admin "Yêu cầu khai lại" for student guidance.
export const requestRevisionStudentGuidance = (id, reason) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.requestRevisionStudentGuidance(id);
  const { response, error } = await apiCall({ ...api, payload: { reason } });
  if (!error && response?.status === 200 && response.data?.success) {
    if (response.data.data) {
      dispatch({
        type: TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_SUCCESS,
        payload: response.data.data,
        meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
      });
    }
    dispatch(notification({ type: 'success', message: 'Đã gửi yêu cầu khai lại' }));
    return true;
  }
  dispatch(notification({
    type: 'error',
    message: response?.data?.message || 'Yêu cầu khai lại thất bại',
  }));
  return false;
};

export const acceptStudentGuidance = (id, accept) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.acceptStudentGuidance(id, accept);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_SUCCESS,
      id: id,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: accept ? "Xác nhận thành công!" : "Hủy xác nhận thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: error?.response?.data?.message || "Thao tác thất bại!",
      }),
    );
    return false;
  }
};

